import { useState } from 'react'
import { PiClockCounterClockwise } from 'react-icons/pi'

import {
  Modal,
  ModalHeader,
  ModalHeading,
  ModalDismiss,
  ModalContent,
  RadioGroup,
  Radio,
  Text,
  VisuallyHidden,
  useRadioState
} from '@vtex/shoreline'

import { Button } from '~/components/Buttons'
import { useAPPTranslation } from '~/i18n/useAPPTranslation'

const LOOKBACK_OPTIONS = [3, 6, 12]

type LookbackSelectorProps = {
  value: number
  onChange: (value: number) => void
}

const LookbackSelector = ({ value, onChange }: LookbackSelectorProps) => {
  const { t } = useAPPTranslation()
  const [isOpen, setIsOpen] = useState(false)

  const radioState = useRadioState({
    value: String(value),
    setValue: next => onChange(Number(next))
  })

  return (
    <>
      <Button
        size="small"
        template="tertiary"
        type="button"
        iconLeft={<PiClockCounterClockwise aria-hidden="true" />}
        text={t('rm:metrics.lookback.button', { months: value })}
        onClick={() => setIsOpen(true)}
      />

      <Modal size="small" open={isOpen} onClose={() => setIsOpen(false)}>
        <ModalHeader>
          <ModalHeading
            style={{ fontSize: '1.25rem', fontWeight: 600, margin: 0 }}
          >
            {t('rm:metrics.lookback.modal.title')}
          </ModalHeading>
          <ModalDismiss />
        </ModalHeader>
        <ModalContent style={{ textAlign: 'left' }}>
          <Text style={{ display: 'block', marginBottom: '0.5rem' }}>
            {t('rm:metrics.lookback.modal.description')}
          </Text>
          <RadioGroup
            state={radioState}
            style={{ marginTop: '-0.75rem' }}
            label={
              <VisuallyHidden>
                {t('rm:metrics.lookback.modal.title')}
              </VisuallyHidden>
            }
          >
            {LOOKBACK_OPTIONS.map(months => (
              <Radio key={months} value={String(months)}>
                {t('rm:metrics.lookback.option', { months })}
              </Radio>
            ))}
          </RadioGroup>
        </ModalContent>
      </Modal>
    </>
  )
}

export default LookbackSelector
